module.exports = __webpack_public_path__ + "img/main-1440.46917601.png";